export const categories = [
  {
    slug: "yanghu",
    name: "猫咪养护",
    description: "从饮食到日常护理，全方位守护猫咪健康",
    icon: "ri-heart-pulse-line",
    count: 128,
    color: "accent",
  },
  {
    slug: "jiankang",
    name: "健康问答",
    description: "疾病预防、症状识别与兽医建议",
    icon: "ri-stethoscope-line",
    count: 96,
    color: "primary",
  },
  {
    slug: "mengtu",
    name: "萌猫图片",
    description: "分享你家主子的可爱瞬间",
    icon: "ri-camera-lens-line",
    count: 256,
    color: "accent",
  },
  {
    slug: "lingyang",
    name: "领养信息",
    description: "给流浪猫咪找一个温暖的家",
    icon: "ri-home-heart-line",
    count: 64,
    color: "primary",
  },
  {
    slug: "xingwei",
    name: "行为解读",
    description: "读懂猫咪的每一个小动作",
    icon: "ri-empathize-line",
    count: 82,
    color: "accent",
  },
  {
    slug: "yinshi",
    name: "饮食营养",
    description: "科学喂养，从选粮到自制猫饭",
    icon: "ri-bowl-line",
    count: 110,
    color: "primary",
  },
];

export const communityStats = {
  members: 328000,
  articles: 12450,
  dailyActive: 8900,
  adoptions: 3200,
};